module.exports = __webpack_public_path__ + "static/media/Movistar.73a0d45e.png";